const css = `.oKYFUa__listItems{width:100%}.oKYFUa__middot{margin-left:6px;margin-right:6px}.oKYFUa__actionableListItem{cursor:pointer;display:inline-flex}.oKYFUa__actionableListItem:hover{text-decoration:underline}.oKYFUa__linkListItemInherit{color:inherit}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"middot":"oKYFUa__middot","linkListItemInherit":"oKYFUa__linkListItemInherit","actionableListItem":"oKYFUa__actionableListItem","listItems":"oKYFUa__listItems"};
